import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialIcon',
  props: {
  icon: {
    type: String,
    required: true,
  },
},
  setup(__props) {

/**
 * This component is using icon from google: https://fonts.google.com/icons?icon.size=24&icon.color=%23e8eaed&icon.set=Material+Icons
 */


return { __sfc: true, }
}

})